import { DECIMAL, INTEGER, FRACTION, GROUP } from '../constants';
import { FormatToParts } from '../interfaces';

const getValueFromParts = (parts: FormatToParts) => {
  return parts
    .map(part => {
      if (part.type === DECIMAL || part.type === INTEGER || part.type === FRACTION || part.type === GROUP) {
        return part.value;
      }
      return null;
    })
    .join('');
};

export default getValueFromParts;
